import { createReducer, on } from '@ngrx/store';
import {
  loadRiskTolerancesFailure,
  loadRiskTolerancesSuccess,
  toggleRiskTolerancesLoading,
} from './risk-tolerances.actions';
import { initialUIState, IRiskTolerancesState } from './risk-tolerances.state';

export const riskTolerancesReducer = createReducer(
  initialUIState,
  on(toggleRiskTolerancesLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadRiskTolerancesSuccess, (state, { riskTolerances }) => ({
    ...state,
    list: riskTolerances,
    isLoading: false,
  })),
  on(loadRiskTolerancesFailure, (state) => ({
    ...state,
    isLoading: false,
  }))
);